import { userStore, res } from "@/BaseComponent";
import { apiService, header } from "@/services/interceptor";
export default {
    async login(fcmToken: string | null, username: string, password: string): Promise<res> {
        const res = {} as res;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(
                "/login",
                {
                    fcmToken: fcmToken,
                    id: username,
                    pw: password,
                },
                { withCredentials: false },
            );

            const user = userStore();
            user.setToken(response.data.token);

            return response.data;
        } catch (error) {
            console.info(error);
        }
        return res;
    },
    async existId(username: string): Promise<res> {
        const res = {} as res;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(
                "/existId",
                {
                    id: username,
                },
                { withCredentials: false },
            );

            return response.data;
        } catch (error) {
            console.info(error);
        }
        return res;
    },
    async findId(name: string, phone: string): Promise<res> {
        const res = {} as res;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(
                "/findId",
                {
                    name: name,
                    phone: phone,
                },
                { withCredentials: false },
            );
            return response.data;
        } catch (error) {
            console.info(error);
        }
        return res;
    },
    async join(param: FormData): Promise<res> {
        const res = {} as res;
        try {
            header.headers["Content-Type"] = "multipart/form-data";
            const response = await apiService().post("/join", param, {
                withCredentials: false,
            });
            return response.data;
        } catch (error) {
            console.info(error);
        }
        return res;
    },
    async requestApplyCode(id: string): Promise<res> {
        const res = {} as res;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(
                "/requestApplyCode",
                {
                    id: id,
                },
                { withCredentials: false },
            );
            return response;
        } catch (error) {
            console.info(error);
        }
        return res;
    },

    async checkApplyCode(id: string, code: string): Promise<res> {
        const res = {} as res;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(
                "/checkApplyCode",
                {
                    applyCode: code,
                    id: id,
                },
                { withCredentials: false },
            );
            return response.data;
        } catch (error) {
            console.info(error);
        }
        return res;
    },
    async updatePassword(code: string, idx: number, password: string): Promise<res> {
        const res = {} as res;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(
                "/updatePassword",
                {
                    applyCode: code,
                    idx: idx,
                    password: password,
                },
                { withCredentials: false },
            );
            return response.data;
        } catch (error) {
            console.info(error);
        }
        return res;
    },
    // 8월까지 만사용
    async addVasSurvey(
        content: string,
        content2: string,
        content3: string,
        date: string,
        hour: number,
        token: string,
        answerList: any = null,
    ) {
        const res = {} as res;
        if (answerList) {
            let content1Value = answerList["content1"];
            answerList["content"] = content1Value;
            delete answerList["content1"];
        }
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(
                "/stress/survey",
                answerList
                    ? answerList
                    : {
                          content: content,
                          content2: hour !== 5 ? content2 : "",
                          content3: hour === 1 ? content3 : "",
                          content4: "",
                          content5: "",
                          content6: "",
                          content7: "",
                          content8: "",
                          content9: "",
                          content10: "",
                          content11: "",
                          date: date,
                          hour: hour,
                          token: token,
                      },
                { withCredentials: false },
            );
            return response.data;
        } catch (error) {
            console.info(error);
        }
        return res;
    },
    async getVasSurvey(date: string, token: string) {
        const res = {} as res;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(`/stress/survey/${date}/${token}`, { withCredentials: false });
            return response.data;
        } catch (error) {
            console.info(error);
        }
        return res;
    },
    async joinSample(param: FormData): Promise<res> {
        const res = {} as res;
        try {
            header.headers["Content-Type"] = "multipart/form-data";
            const response = await apiService().post("/joinSample", param, {
                withCredentials: false,
            });
            return response.data;
        } catch (error) {
            console.info(error);
        }
        return res;
    },
    async attendanceForMobile(date: string, token: string){
        const res = {} as res;
        try {
            header.headers["Content-Type"] = "multipart/form-data";
            const response = await apiService().post(`/request/attendanceForMobile/${token}/${date}`, { withCredentials: false });
            return response.data;
        } catch (error) {
            console.info(error);
        }
        return res;
    }
};
